import { createFileRoute } from "@tanstack/react-router";

import { parseBlocksSearch } from "@/features/accounts";
import { PhoneBlocksPage } from "@/features/accounts/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/clients/blocks")({
  validateSearch: strictSearch(parseBlocksSearch),
  component: Blocks,
});

function Blocks() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PhoneBlocksPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
